export const testimonials = [
  {
    id: 1,
    image: "./img/mansi.png",
    name: "Mansi Kumari",
    text: " Embark on a journey across the open sea and tantalize your taste buds with 4 to 7 course fine dining created by experienced chefs specifically for your luxury cruise.  ",
  },
  {
    id: 2,
    image: "./img/vivek.png",
    name: "Vivek Sharma",
    text: "Making memories on the high seas is a perfect way to plan the perfect birthday trip! With instagrammable moments around every    corner, this is an ideal experience for someone of any age.",
  },
  {
    id: 3,
    image: "./img/pooja.png",
    name: "Pooja Naik",
    text: "The Nauti Amigo is a tallship that has been exciting vacationers in search of something truly remarkable.",
  },
  {
    id: 4,
    image: "./img/rohit.png",
    name: "Rohit Singh",
    text: " Embark on a journey across the open sea and tantalize your taste buds with 4 to 7 course fine dining created by experienced chefs specifically for your luxury cruise.  ",
  },
];

export const traveldest = [
  {
    id: 1,
    text: "Panjim",
    img: "https://dynamic-media-cdn.tripadvisor.com/media/photo-o/0e/8e/fc/81/a-walk-through-calangute.jpg?w=500&h=400&s=1",
    img1: "https://img.traveltriangle.com/blog/wp-content/uploads/2020/01/Beaches-Near-Panjim_14th-jan.jpg",
    alt: "prod1",
  },
  {
    id: 2,
    text: "Vasco",
    img: "http://t1.gstatic.com/licensed-image?q=tbn:ANd9GcQvm3QYzdDUv6JiYNK2iPJer9rBG4vlUF-10TkOzFrbJrjth6qbEklHhCrYTwjOsGrA",
    img1: "https://dynamic-media-cdn.tripadvisor.com/media/photo-o/14/0b/5a/3f/lrm-export-20180210-210205.jpg?w=500&h=400&s=1",
    alt: "prod2",
  },
  {
    id: 3,
    text: "Mapusa",
    img: "http://t1.gstatic.com/licensed-image?q=tbn:ANd9GcST07B7Rnxnas4Pm7GubLDtlbZlsc_sq6cS7gPYqSzd52CXYfItvwtqZEGl2h1w015t",
    img1: "https://gumlet.assettype.com/gomantaktimes%2F2023-01%2F570c2c0d-8e3f-4e52-bc6c-84db26c36345%2FKatia_Quintype_custom_size__6_.png?auto=format%2Ccompress&w=1200",
    alt: "prod3",
  },
  {
    id: 4,
    text: "Margao",
    img: "http://t2.gstatic.com/images?q=tbn:ANd9GcRx-XKJoLvIIfHLU_OdUTlcmwa4sRVYu2XTjNnA7gL2UaaSWcBzlX9RWreK8VS2VyIk4Bwu",
    img1: "https://static.trip101.com/paragraph_media/pictures/000/130/304/large/Margao_city_hall.png?1492178842",
    alt: "prod4",
  },
  {
    id: 5,
    text: "Canacona",
    img: "http://t0.gstatic.com/licensed-image?q=tbn:ANd9GcQ_zm8HA3YH1b4_XCsZAGBAgPoAiXfyD__4KhyG3F3xVhIhHuBon32E_04qgpXlYhWl",
    img1: "https://upload.wikimedia.org/wikipedia/commons/thumb/f/f4/Palolem_beach%2CGoa_-_panoramio.jpg/800px-Palolem_beach%2CGoa_-_panoramio.jpg?20170603073304",
    alt: "prod5",
  },
  {
    id: 6,
    text: "Mormugao",
    img: "http://t1.gstatic.com/licensed-image?q=tbn:ANd9GcRhTqQ9s4lfTmzgtDtnDpDPrJ8kjHR-5PA3pC9EXdoWFPWqHpfuE0If8mLKLfpDwgVZ",
    img1: "https://img.traveltriangle.com/blog/wp-content/uploads/2020/01/Beaches-Near-Panjim_14th-jan.jpg",
    alt: "prod6",
  },
];

export const worldwide = [
  {
    id: 1,
    text: "Palolem Beach",
    img: "./img/ttpalolem.png",
    alt: "prod1",
  },
  {
    id: 2,
    text: "Arambol Beach",
    img: "./panjim.png",
    alt: "prod2",
  },
  {
    id: 3,
    text: "Vagator Beach ",
    img: "./img/ttvagator.png",
    alt: "prod3",
  },
];

export const travelData = [
  {
    imgurl: "./img/vishal/travel1.png",
    heading: "Cruise party with open bar",
    para: "Get ready for an unforgettable night on the water with our Cruise Party and Open Bar! Dance the night away to our onboard DJ with unlimited drinks from our fully-stocked bar.",
    rating: 4,
    price: "5000",
    title: "Combo Deal",
    color: "#C761EE",
  },
  {
    imgurl: "./img/vishal/travel2.png",
    heading: "New year party",
    para: "Join us for an unforgettable New Year's celebration on our luxury cruise! With entertainment, music, and delicious food, you won't want to miss out.",
    rating: 4.5,
    price: "4000",
    title: "NY2022",
    color: "#477ce3",
  },
  {
    imgurl: "./img/vishal/travel3.png",
    heading: "Cruise Party Package",
    para: "Discover the beauty of Mandovi River and make unforgettable memories with loved ones on our Scenic River Cruise at Nauti Amigo. ",
    rating: 4.5,
    price: "4000",
    title: "Package Deal",
    color: "#477ce3",
  },
  // {
  //   imgurl: "./img/vishal/travel4.png",
  //   heading:
  //     "For boat lovers by allyson klass the Nauti Amigo has something exciting this festive season",
  //   title: "FOR BOAT LOVERS",
  //   rating: 4.6,
  //   price: "4000",
  // },
  // {
  //   imgurl: "./img/vishal/travel5.png",
  //   heading: "Royal Albatross opens to public at resorts world sentosa",
  //   title: "SET SAIL ON THE Nauti Amigo",
  //   rating: 3.5,
  //   price: "4000",
  // },
  // {
  //   imgurl: "./img/vishal/travel7.png",
  //   heading:
  //     "mission rasi mission rasi, involves two replica 19th Century Cornish Pilot Boats being rowed over",
  //   title: "MISSION RASI",
  //   rating: 4,
  //   price: "4000",
  // },
];

export const sailing = [
  {
    id: 1,
    imgurl: "./img/vishal/party-birth.png",
    title: " Birthday Package",
    prise: "399",
    desc: "Birthday Dinner Cruise Super Yacht Nauti Amigo",
  },
  {
    id: 2,
    imgurl: "./corporate.png",
    title: "Corporate Package",
    prise: "399",
    desc: "Need a unique venue for your corporate event? Look no further. Our customizable event spaces offer the perfect blend of functionality and style. From boardrooms to ballrooms, we can accommodate groups of any size. Let us help you create an unforgettable event.",
  },
  {
    id: 3,
    imgurl: "./img/vishal/party3-birth.png",
    title: "Anniversery Package",
    prise: "399",
    desc: "As our saying goes, Marriages are made in heaven; but celebrated aboard the Nauti Amigo!",
  },
];

export const birthData = [
  {
    id: 1,
    img: "./img/vishal/pack3.png",
    text: "Anniversery Package",
    start: "Starts From Rs.499",
    desc: "If you are Looking to host your dream wedding,the Nauti Amigo is the perfect venue.",
    alt: "prod1",
  },
  {
    id: 3,
    text: "Wedding Packages",
    img: "./img/vishal/m6.png",
    desc: "Secrets are best unveiled at unforgettable locations and what better way than...",
    start: "Starts From Rs.499",
    alt: "prod3",
  },
];

export const ourProd = [
  {
    id: 1,
    text: "Breakfast",
    img: "./breackfast.png",
    alt: "prod1",
  },
  { id: 2, text: "Sunset", img: "./sunset.png", alt: "prod2" },
  { id: 3, text: "Dinner", img: "./dinning.jpg", alt: "prod3" },
  {
    id: 4,
    text: "Corporate Events",
    img: "./corporate.png",
    alt: "prod4",
  },
  {
    id: 5,
    text: "Birthday Party",
    img: "./bday02.png",
    alt: "prod5",
  },
  {
    id: 6,
    text: "Proposal",
    img: "./praposal.png",
    alt: "prod6",
  },
];

export const sailingsixdata = [
  {
    id: 1,
    imgurl: "./img/vishal/pack1.png",
    title: ": PARTY – MUSIC & MORE",
    timingInfo: "Dinner Cruising From 7PM- 9:30 PM",
    cruise: "DINNER CRUISE",
    desc: "Embark on an evening of exquisite dining and entertainment on board our dinner cruise in Goa. Immerse yourself in the scenic beauty of the Mandovi river as you enjoy a delicious buffet, featuring both vegetarian and non-vegetarian options. Sip on a complimentary beer or mocktail while enjoying live music on deck. Don't miss out on this one-of-a-kind experience.",
    boardingPoint: "Mandovi river, GOA",
    bookDescription: " dinner cruise now!",
  },
  {
    id: 2,
    imgurl: "./sunset.png",
    title: ": MUSIC, DRINKS & SCENIC VIEWS",
    timingInfo: "Sundowner sailing from 5PM- 7PM",
    cruise: "SUNDOWNER CRUISE",
    desc: "Cruise into the sunset with us and enjoy live music, drinks, and scenic views. This tour features a relaxing evening of cruising with a complimentary drink (Beer/Mocktail) and live entertainment. See the picturesque views of the sunset and soak in the tranquil ambiance of the sea.",
    boardingPoint: "Mandovi river, GOA",
    bookDescription: " Sundowner cruise now!",
  },
  {
    id: 3,
    imgurl: "./breackfast.png",
    title: ": BREAKFAST & SCENIC VIEWS",
    timingInfo: "Breakfast Cruising from 8AM - 10AM",
    cruise: "RIVER CRUISE",
    desc: "Start your day on the right foot with a delicious breakfast onboard a scenic river cruise in Goa. Enjoy a buffet breakfast (veg/non-veg), along with a complimentary tea/coffee and breathtaking views of the Mandovi River.",
    boardingPoint: "Mandovi river, GOA",
    bookDescription: " Breakfast cruise now!",
  },
];

export const packagePageData = [
  {
    id: 1,
    text: "Birthday Packages",
    start: "Starts From Rs.499",
    desc: "Set sail on your special day and celebrate in style with the Nauti Amigo. Choose from our exclusive dining options, signature cocktails, and personalized touches to make it a birthday to remember",
    img: "./img/vishal/pack1.png",
    alt: "prod1",
  },
  {
    id: 2,
    text: "Corporate Packages",
    img: "./citylight1.jpg",
    desc: "Need a unique venue for your corporate event? Look no further. Our customizable event spaces offer the perfect blend of functionality and style. From boardrooms to ballrooms, we can accommodate groups of any size. Let us help you create an unforgettable event.",
    start: "Starts From Rs.499",
    alt: "prod2",
  },
  {
    id: 3,
    text: "Anniversary Packages",
    img: "./img/vishal/party3-birth.png",
    desc: " Celebrate your wedding anniversary in style with our carefully curated packages. From intimate dinners to grand celebrations, we've got you covered. Let our experienced event planners take care of every detail and create a day to remember.",
    start: "Starts From Rs.499",
    alt: "prod3",
  },
  {
    id: 4,
    text: "Sundowner Packages",
    img: "./sunset.png",
    desc: "Experience the breathtaking beauty of sunset with our exclusive Sundowner Package. As the sun dips below the horizon, enjoy a glass of sparkling wine or a refreshing cocktail from the comfort of our luxurious deck. Take in the stunning panoramic views of the ocean as the sky transforms into a spectacular display of oranges, pinks, and purples.",
    start: "Starts From Rs.499",
    alt: "prod4",
  },
  {
    id: 5,
    text: "Proposal Packages",
    img: "./praposal.png",
    desc: "Looking to propose in a unique and unforgettable way? Our proposal Package offers a private balcony or secluded spot on board for the perfect moment. Our experienced team will work with you to create a personalized experience. We'll even provide a professional photographer to capture the moment.",
    start: "Starts From Rs.499",
    alt: "prod5",
  },
  {
    id: 6,
    text: "Dinner Package",
    img: "./dinner1.jpg",
    desc: "Treat yourself to an unforgettable dining experience on your next cruise with our Dinner Package. Enjoy a three-course gourmet meal, fine wine and cocktails, and stunning ocean views. ",
    start: "Starts From Rs.499",
    alt: "prod6",
  },
];
